//SECTION SS26

console.log('ss26 - log jhon');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.slider').forEach((sliderEl) => {
    const $slider = $(sliderEl);

    $slider.slick({
      dots: false,
      infinite: true,
      arrows: false,
      speed: 300,
      slidesToShow: 1,
      centerMode: false,
      variableWidth: true,
      fade: false,
      autoplay: false,
      autoplaySpeed: 2000,
    });

    const container = sliderEl.closest('[data-slider-wrap]') ?? sliderEl.parentElement;
    container.querySelector('.slider-prev')?.addEventListener('click', () => $slider.slick('slickPrev'));
    container.querySelector('.slider-next')?.addEventListener('click', () => $slider.slick('slickNext'));
  });
});
/*document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('#section_ss26');
  const imgs = section.querySelectorAll('img:not(.colonna_4_img)');
  const videos = section.querySelectorAll('video:not(.video_bottom, .video_front)');
  const els = [...imgs, ...videos];

  const banner = section.querySelectorAll('.banner');
  const h2_ss26 = section.querySelectorAll('#section_ss26 > div:not(.riga, #righe_vert, .bar) h2');

  // ─── BAR STICKY — .bar_fixed quando il suo top tocca il top viewport ────
  const bar = section.querySelector('.bar');
  if (bar) {
    ScrollTrigger.create({
      trigger: bar,
      start: 'top top+=10',
      end: 'max',
      pin: true,
      onEnter: () => bar.classList.add('bar_fixed'),
      onLeaveBack: () => bar.classList.remove('bar_fixed'),
    });
  }

  // ─── RIGHE VERTICALI — si "disegnano" in scrub ──────────────────────────

  const righeVert = section.querySelectorAll('.riga_vert');
  const righeVertContainer = section.querySelector('#righe_vert');

  righeVert.forEach(function (el, i) {
    gsap.from(el, {
      scaleY: 0,
      transformOrigin: 'top center',
      ease: 'none',
      scrollTrigger: {
        trigger: righeVertContainer,
        start: 'top center',
        end: 'bottom bottom',
        scrub: 1.2 + i * 1, // 1.2 / 1.6 / 2.0 / 2.4 / 2.8
      },
    });
  });

  //els ctrl
  if (window.innerWidth < 999) {
    var startData = 'top center+=200';
    var endData = 'top 55%';
  } else {
    var startData = 'top center+=100';
    var endData = 'top 25%';
  }
  els.forEach(function (el, i) {
    if (i == 0) return;
    gsap.from(el, {
      opacity: 0,
      scale: 0.85,
      y: 100,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: startData, // inizio: top elemento | center viewport
        end: endData, // fine:   top elemento | 25% viewport
        scrub: 2, // 1 = smoothing di 1 secondo
        //markers: true,
      },
    });
  });

  // ─── TITOLIO SEZIONI ───────────────────────────────
  //els titoli
  if (window.innerWidth < 999) {
    var startDataTitoli = 'top bottom-=150';
    var endDataTitoli = 'top center+=150';
  } else {
    var startDataTitoli = 'top bottom-=200';
    var endDataTitoli = 'top center-=200';
  }
  h2_ss26.forEach(function (el, i) {
    if (i == 0) return;
    gsap.from(el, {
      opacity: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: startDataTitoli,
        end: endDataTitoli,
        scrub: 0,
        //markers: true,
      },
    });
  });

  // ─── TOP DINAMICO — righe_vert + riga_vert_01/05 ────────────────────────
  if (window.innerWidth < 999) {
    var extraSpace = 150;
    var heroEl = document.querySelector('#hero.mob');
  } else {
    var extraSpace = 200;
    var heroEl = document.querySelector('#hero.desk');
  }
  const heroH = (heroEl?.offsetHeight ?? 0) + extraSpace;
  const topVal = heroH + 'px';

  ['#righe_vert', '.riga_vert_01', '.riga_vert_05'].forEach(function (sel) {
    const el = document.querySelector(sel);
    if (el) el.style.top = topVal;
  });

  if (window.innerWidth < 999) return;

  // ─── VIDEO REVEAL — pin + scrub: video_front slide ─────────────────────
  const grid01sez03 = section.querySelector('#grid_section_01 .sez03');
  if (grid01sez03) {
    const videoFront = grid01sez03.querySelector('.video_front');
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: grid01sez03,
        start: 'bottom bottom-=100',
        end: '+=2400',
        pin: true,
        pinSpacing: true,
        scrub: true,
        //markers: true,
      },
    });
    tl.to({}, { duration: 1 }) // — pausa 800px
      .to(videoFront, { x: -800, ease: 'none', duration: 1 }) // — slide 800px
      .to({}, { duration: 1 }); // — pausa 800px
  }

  // ─── KEN BURNS — bg-image zoom su .banner ───────────────────────────────

  banner.forEach(function (el) {
    gsap.fromTo(
      el,
      { backgroundSize: '100%' },
      {
        backgroundSize: '130%',
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom', // il banner entra nella viewport dal basso
          end: 'bottom top', // il banner esce dalla viewport in alto
          scrub: 0,
        },
      },
    );

    // ─── PARALLAX TESTO — span dentro .banner h2 ──────────────────────────
    const spans = el.querySelectorAll('h2 span');
    const baseX = 80; // px massimi per il primo span
    const step = 25; // decremento per ogni span successivo

    spans.forEach(function (span, i) {
      gsap.to(span, {
        x: Math.max(baseX - i * step, 10), // almeno 10px per tutti
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0,
        },
      });
    });
  });
});*/
